import React, { useEffect, useState, useRef } from 'react';
import { API_URL } from '../config.js';
import './NivelRepaso.css';
import AlternativasGraficas from './AlternativasGraficas';
import ChatWidget from '../components/ChatWidget';
import Images3Question from './Images3Question';
import { useNavigate } from 'react-router-dom'; // 👈 NUEVO

/* ==== Carga dinámica de imágenes ==== */
const imgRoles = {};
const imgGenerales = {};
const img3 = {};
function keyFrom(name) {
  return String(name || '')
    .replace(/\.(png|jpe?g|svg|webp)$/i, '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s-]+/g, '_');
}
function importAll(ctx, target) {
  ctx.keys().forEach((key) => {
    const clean = key.replace('./', '');
    target[keyFrom(clean)] = ctx(key);
  });
}
importAll(require.context('../assets/img_roles', false, /\.(png|jpe?g|svg|webp)$/), imgRoles);
importAll(require.context('../assets/img_generales', false, /\.(png|jpe?g|svg|webp)$/), imgGenerales);
importAll(require.context('../assets/img_3imagenes', false, /\.(png|jpe?g|svg|webp)$/), img3);

const fondo = imgGenerales['fondo'];
const isInfoValue = (v) =>
  String(v ?? '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim() === 'info';

const SWIPE_INTENT_THRESHOLD = 25;  
const HOLD_DELAY_DESKTOP = 120;      
const HOLD_DELAY_MOBILE = 80;       

const NivelRepaso = () => {
  const [cargando, setCargando] = useState(true);
  const [mostrarEfectoEnPantalla, setMostrarEfectoEnPantalla] = useState(false);
  const [textoEfectoPantalla, setTextoEfectoPantalla] = useState('');
  const [preguntas, setPreguntas] = useState([]);
  const [preguntaActual, setPreguntaActual] = useState(null);

  const [posicionX, setPosicionX] = useState(0);
  const [opcionPendiente, setOpcionPendiente] = useState(null);
  const confirmandoRef = useRef(false);
  const pendienteDesdeRef = useRef(0);
  const [startX, setStartX] = useState(null);
  const [startY, setStartY] = useState(null); // 👈 NUEVO

  const [usuario, setUsuario] = useState('Jugador');
  const [tiempo, setTiempo] = useState(0);

  const [mostrarImagen, setMostrarImagen] = useState(false);

  const [bloquearInteraccion, setBloquearInteraccion] = useState(false);
  const [mostrarOpciones, setMostrarOpciones] = useState(true);

  const [readyNext, setReadyNext] = useState(false); 
  const [visitedIds, setVisitedIds] = useState(new Set()); 

  const inputTipo = useRef(null);
  const handleEndCalledRef = useRef(false);
  const isFinishingRef = useRef(false); 

  const [historial, setHistorial] = useState([]);   // ej: ["1","3","7",...]

  const navigate = useNavigate(); 

  // refs para controlar intención de swipe
  const isDraggingRef = useRef(false);     
  const holdTimeoutRef = useRef(null);    

  const getTipo = (p) => {
    const raw = (p?.TipoPregunta || 'swipe')
      .toString().trim().toLowerCase()
      .normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    const alias = {
      'alternativas graficas': 'alternativasgraficas',
      'alternativas_graficas': 'alternativasgraficas',
      'alternativas gráficas': 'alternativasgraficas',
      'imagenmarcas': 'alternativasgraficas',
      '3 imagenes': 'imagenes3',
      '3_imagenes': 'imagenes3',
      '3 imágenes': 'imagenes3',
      'tres imagenes': 'imagenes3',
      'tres_imagenes': 'imagenes3',
    };
    return alias[raw] || raw;
  };

  function resolveRol(rol) { return imgRoles[keyFrom(rol)] || imgRoles['enfermera'] || null; }
  function resolveGeneral(nombre) { return imgGenerales[keyFrom(nombre)] || null; }
  function resolveImg3(nombre) { return img3[keyFrom(nombre)] || null; }
  const hayImagenValida = !!resolveGeneral(preguntaActual?.Imagen || preguntaActual?.ImagenGral);

  const handleMove = (x, y = 0) => {
    if (startX === null || bloquearInteraccion || opcionPendiente || mostrarImagen || getTipo(preguntaActual) !== 'swipe') return;

    // si aún no se activó el "drag", no hacemos nada
    if (!isDraggingRef.current) return;

    const dx = x - startX;
    const dy = y - (startY ?? y);

    // Requerimos intención horizontal clara
    if (Math.abs(dx) < SWIPE_INTENT_THRESHOLD || Math.abs(dx) < Math.abs(dy)) {
      setPosicionX(0);
      return;
    }

    setPosicionX(dx);
  };

  // alto seguro
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    setVh();
    window.addEventListener('resize', setVh);
    return () => window.removeEventListener('resize', setVh);
  }, []);

  // limpiar timeout de hold al desmontar
  useEffect(() => {
    return () => {
      if (holdTimeoutRef.current) {
        clearTimeout(holdTimeoutRef.current);
        holdTimeoutRef.current = null;
      }
    };
  }, []);

  // Cargar usuario y preguntas
  useEffect(() => {
    const nombre = localStorage.getItem('usuario');
    if (nombre) setUsuario(nombre);

    (async () => {
      try {
        const res = await fetch(`${API_URL}/preguntas-nivel-repaso?ts=${Date.now()}`);
        const data = await res.json();
        const arr = Array.isArray(data) ? data : (data.preguntas || []);
        const normal = arr.map(p => ({ ...p, ID: String(p.ID || '').trim() })).filter(p => p.ID);
        setPreguntas(normal);
        const inicial = normal.find(p => p.ID === '1') || normal[0] || null;
        setPreguntaActual(inicial);
        if (inicial) {
          setVisitedIds(new Set([inicial.ID]));
          setHistorial([String(inicial.ID)]);   
        }
      } catch (e) {
        console.error('❌ Error cargando preguntas:', e);
      } finally {
        setCargando(false);
      }
    })();
  }, []);

  // timer
  useEffect(() => {
    const interval = setInterval(() => setTiempo(t => t + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  // marcar visitado cuando cambia la pregunta
  useEffect(() => {
    if (!preguntaActual?.ID) return;
    setVisitedIds(prev => {
      const n = new Set([...prev]);
      n.add(String(preguntaActual.ID));
      return n;
    });
    // reset del flag para botones de “Siguiente” en tipos especiales
    setReadyNext(false);
  }, [preguntaActual?.ID]);

  const reemplazarNombre = (texto) => {
    if (!texto) return '';
    const nombreFormateado = `<strong><em>${usuario}</em></strong>`;
    return texto.replace(/\[NombreUsuario\]/g, nombreFormateado).replace(/\n/g, '<br />');
  };

  const registrarRespuesta = async ({
    respuesta_usuario,
    es_correcta
  }) => {
    try {
      const session_id =
        localStorage.getItem('sesion') ||
        `SESS_${Date.now()}`;

      localStorage.setItem(
        'sesion',
        session_id
      );

      const response = await fetch(
        `${API_URL}/api/answer`,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json'
          },
          body: JSON.stringify({
            session_id,
            nombreUsuario:
              usuario,
            nivel:
              'Repaso',
            pregunta_id:
              preguntaActual?.ID,
            tipo_pregunta:
              getTipo(preguntaActual),
            respuesta_usuario,
            es_correcta:
              es_correcta ?? null,
            tiempo_seg:
              tiempo,
            device:
              /Mobi/.test(
                navigator.userAgent
              )
                ? 'mobile'
                : 'desktop',
            score_before:
              0
          })
        }
      );

      const data =
        await response
          .json()
          .catch(() => null);

      if (
        !response.ok ||
        data?.ok === false
      ) {
        throw new Error(
          data?.error ||
          `HTTP ${response.status}`
        );
      }

      return true;
    } catch (error) {
      console.error(
        '❌ Error registrando respuesta de Repaso:',
        error
      );

      return false;
    }
  };

  const handleStart = (x, tipo, y = 0) => {
    if (bloquearInteraccion || opcionPendiente || mostrarImagen || getTipo(preguntaActual) !== 'swipe') return;

    confirmandoRef.current = false;
    inputTipo.current = tipo;
    setStartX(x);
    setStartY(y);
    setPosicionX(0);

    const isMobile = /Mobi/.test(navigator.userAgent);

    // En desktop con mouse: requerimos un pequeño "hold" antes de activar el swipe
    if (tipo === 'mouse' && !isMobile) {
      isDraggingRef.current = false;
      if (holdTimeoutRef.current) {
        clearTimeout(holdTimeoutRef.current);
      }
      holdTimeoutRef.current = setTimeout(() => {
        isDraggingRef.current = true;
      }, HOLD_DELAY_DESKTOP);
    } else if (tipo === 'touch') {
      // En touch también pedimos un mini-hold para evitar swipes accidentales 👈 NUEVO
      isDraggingRef.current = false;
      if (holdTimeoutRef.current) {
        clearTimeout(holdTimeoutRef.current);
      }
      holdTimeoutRef.current = setTimeout(() => {
        isDraggingRef.current = true;
      }, HOLD_DELAY_MOBILE);
    } else {
      // mouse en móvil u otros casos raros: drag inmediato
      isDraggingRef.current = true;
    }
  };

  // siempre mostramos OK para cerrar el efecto
  const cerrarEfecto = () => {
    setMostrarEfectoEnPantalla(false);
    setTextoEfectoPantalla('');
    setBloquearInteraccion(false);
    setMostrarOpciones(true);
    handleEndCalledRef.current = false;
  };

  // SWIPE: deslizar solo propone; tocar la alternativa verde confirma.
  const limpiarSwipe = () => {
    setOpcionPendiente(null);
    setPosicionX(0);
    setStartX(null);
    setStartY(null);
    inputTipo.current = null;
    handleEndCalledRef.current = false;
    isDraggingRef.current = false;
    confirmandoRef.current = false;
  };

  // Si hay una alternativa pendiente, cualquier toque fuera del recuadro la cancela.
  useEffect(() => {
    if (!opcionPendiente) return;
    const cancelarFuera = (event) => {
      if (event.target.closest?.('.repaso-opcion-confirmable')) return;
      limpiarSwipe();
    };
    document.addEventListener('pointerdown', cancelarFuera, true);
    return () => document.removeEventListener('pointerdown', cancelarFuera, true);
  }, [opcionPendiente]);

  const handleEnd = (tipo) => {
    if (holdTimeoutRef.current) {
      clearTimeout(holdTimeoutRef.current);
      holdTimeoutRef.current = null;
    }
    const habiaArrastre = isDraggingRef.current;
    isDraggingRef.current = false;

    if (getTipo(preguntaActual) !== 'swipe' || opcionPendiente || mostrarImagen) return;
    if (bloquearInteraccion || tipo !== inputTipo.current || handleEndCalledRef.current) return;
    handleEndCalledRef.current = true;

    if (!habiaArrastre || Math.abs(posicionX) <= 120) {
      limpiarSwipe();
      return;
    }

    const letra = posicionX < 0 ? 'A' : 'B';
    // Posición fija para que el usuario pueda soltar la tarjeta y leer la opción.
    setPosicionX(letra === 'A' ? -145 : 145);
    setOpcionPendiente(letra);
    pendienteDesdeRef.current = Date.now();
    setStartX(null);
    setStartY(null);
    inputTipo.current = null;
  };

  const confirmarOpcionSwipe = (letra) => {
    if (opcionPendiente !== letra || confirmandoRef.current) return;
    // Evita confirmar con el click sintético del mismo gesto táctil que soltó la carta.
    if (Date.now() - pendienteDesdeRef.current < 350) return;
    confirmandoRef.current = true;

    const puntajeTexto = letra === 'A' ? (preguntaActual.PuntajeA || '') : (preguntaActual.PuntajeB || '');
    const efecto = letra === 'A'
      ? (preguntaActual.FeedbackA_HTML || preguntaActual.FeedbackA)
      : (preguntaActual.FeedbackB_HTML || preguntaActual.FeedbackB);
    const siguiente = letra === 'A' ? preguntaActual.SiguienteIDA : preguntaActual.SiguienteIDB;
    const esInfo = isInfoValue(puntajeTexto);
    const parsed = parseInt(puntajeTexto, 10);
    const es_correcta = esInfo ? 'Info' : (!Number.isNaN(parsed) && parsed > 0);

    // La lógica de registro y feedback es la original; ahora se ejecuta solo al tocar la opción.
    registrarRespuesta({ respuesta_usuario: letra, es_correcta });
    setBloquearInteraccion(true);
    setMostrarOpciones(false);
    setTextoEfectoPantalla(reemplazarNombre(efecto || ''));
    setMostrarEfectoEnPantalla(Boolean(efecto));
    setOpcionPendiente(null);
    setPosicionX(0);
    setStartX(null);
    setStartY(null);

    if (!efecto) {
      avanzar(siguiente);
    } else {
      (window)._nextRepaso = String(siguiente || '');
    }
    handleEndCalledRef.current = false;
  };

  // util: normalizar
  const norm = (s) =>
    String(s || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

  const goSeleccionNivel = () => {
    if (isFinishingRef.current) return;
    isFinishingRef.current = true;
    navigate('/seleccionar-nivel');
  };

  // avanzar por SiguienteID* o salir si “fin”
  const avanzar = async (siguiente) => {
    if (!siguiente) return;

    if (norm(siguiente) === 'fin') {
      // comprobar si visitó todas las preguntas (excluyendo "1000")
      const idsValidos = preguntas
        .filter(p => p.ID && p.ID !== '1000')
        .map(p => String(p.ID));
      const visitedAll = idsValidos.every(id => visitedIds.has(id));
      try {
        const response =
          await fetch(
            `${API_URL}/repaso-finalizar`,
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json'
              },
              body: JSON.stringify({
                nombreUsuario:
                  usuario,
                visitedAll
              })
            }
          );

        const data =
          await response
            .json()
            .catch(() => null);

        if (
          !response.ok ||
          data?.ok === false
        ) {
          throw new Error(
            data?.error ||
            `HTTP ${response.status}`
          );
        }

        goSeleccionNivel();
        return;
      } catch (error) {
        console.error(
          '❌ No se pudo finalizar correctamente el Repaso:',
          error
        );

        isFinishingRef.current =
          false;

        return;
      }

    }

    const proxima = preguntas.find(p => p.ID === String(siguiente));
    if (!proxima) return;

    setPreguntaActual(proxima);
    setHistorial(prev => [...prev, String(proxima.ID)]);  // <— apilar ID

    setMostrarEfectoEnPantalla(false);
    setTextoEfectoPantalla('');
    setBloquearInteraccion(false);
    setMostrarOpciones(true);
    setReadyNext(false);
    limpiarSwipe();
  };

  // botón “Volver” — retrocede N veces usando la pila
  const irAnteriorPorBoton = () => {
    // Si ya estamos en la primera carta del historial…
    if (historial.length <= 1) {
      // …y además es el ID 1, vuelve a la selección de nivel
      if (String(preguntaActual?.ID) === '1') {
        goSeleccionNivel();
      }
      return;
    }

    // Saca el último ID y ve al anterior
    setHistorial(prev => {
      const next = prev.slice(0, -1);                 // quita el actual
      const prevId = next[next.length - 1];           // penúltimo = nuevo actual
      const anterior = preguntas.find(p => p.ID === prevId);
      if (anterior) setPreguntaActual(anterior);
      return next;
    });

    // limpia estados visuales
    setMostrarEfectoEnPantalla(false);
    setTextoEfectoPantalla('');
    setBloquearInteraccion(false);
    setMostrarOpciones(true);
    setReadyNext(false);
    limpiarSwipe();
  };

  // siguiente para tipos especiales (aparece solo cuando se “vieron todas las opciones”)
  const nextIdFromPregunta = (p) => {
    return p.SiguienteIDA || p.SiguienteIDB || p.SiguienteIDC || p.SiguienteIDD || '';
  };

  const renderPregunta = () => {
    if (!preguntaActual) return null;
    const tipo = getTipo(preguntaActual);

    if (tipo === 'imagenes3') {
      return (
        <>
          <Images3Question
            pregunta={preguntaActual}
            onNext={(id) => avanzar(id)}
            reemplazarNombre={reemplazarNombre}
            resolveImg3={resolveImg3}
            onAllOptionsSeen={() => setReadyNext(true)}
            getLives={() => 5}
            noLivesId="1000"
          />
          {readyNext && (
            <button className="btn-ok-continuar" onClick={() => avanzar(nextIdFromPregunta(preguntaActual))}>
              ➡️ Siguiente
            </button>
          )}
        </>
      );
    }

    if (tipo === 'alternativasgraficas') {
      return (
        <>
          <AlternativasGraficas
            pregunta={preguntaActual}
            onNext={(id) => avanzar(id)}
            reemplazarNombre={reemplazarNombre}
            resolveGeneral={resolveGeneral}
            onAllOptionsSeen={() => setReadyNext(true)}
            getLives={() => 5}
            noLivesId="1000"
          />
          {readyNext && (
            <button className="btn-ok-continuar" onClick={() => avanzar(nextIdFromPregunta(preguntaActual))}>
              ➡️ Siguiente
            </button>
          )}
        </>
      );
    }

    // SWIPE
    return (
      <div
        className="swipe-container"
        style={{ touchAction: 'pan-y', zIndex: 5 }}
        onTouchStart={(e) => handleStart(e.touches[0].clientX, 'touch', e.touches[0].clientY)}
        onTouchMove={(e) => handleMove(e.touches[0].clientX, e.touches[0].clientY)}
        onTouchEnd={() => handleEnd('touch')}
        onMouseDown={(e) => handleStart(e.clientX, 'mouse', e.clientY)}
        onMouseMove={(e) => startX !== null && handleMove(e.clientX, e.clientY)}
        onMouseUp={() => handleEnd('mouse')}
        onMouseLeave={() => handleEnd('mouse')}
      >
        {mostrarOpciones && (
          <>
            <div
              className={`opcion-izquierda ${posicionX < -30 ? 'mostrar' : ''} ${opcionPendiente === 'A' ? 'repaso-opcion-confirmable' : ''}`}
              role={opcionPendiente === 'A' ? 'button' : undefined}
              tabIndex={opcionPendiente === 'A' ? 0 : undefined}
              aria-label={opcionPendiente === 'A' ? 'Confirmar opción izquierda' : undefined}
              onClick={(e) => { if (opcionPendiente === 'A') { e.stopPropagation(); confirmarOpcionSwipe('A'); } }}
              onKeyDown={(e) => { if (opcionPendiente === 'A' && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); confirmarOpcionSwipe('A'); } }}
            >
              {preguntaActual.OpcionA}
            </div>
            <div
              className={`opcion-derecha ${posicionX > 30 ? 'mostrar' : ''} ${opcionPendiente === 'B' ? 'repaso-opcion-confirmable' : ''}`}
              role={opcionPendiente === 'B' ? 'button' : undefined}
              tabIndex={opcionPendiente === 'B' ? 0 : undefined}
              aria-label={opcionPendiente === 'B' ? 'Confirmar opción derecha' : undefined}
              onClick={(e) => { if (opcionPendiente === 'B') { e.stopPropagation(); confirmarOpcionSwipe('B'); } }}
              onKeyDown={(e) => { if (opcionPendiente === 'B' && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); confirmarOpcionSwipe('B'); } }}
            >
              {preguntaActual.OpcionB}
            </div>
          </>
        )}

        {mostrarEfectoEnPantalla && textoEfectoPantalla.trim() !== '' ? (
          <div className="efecto-desplegado">
            <p dangerouslySetInnerHTML={{ __html: textoEfectoPantalla }} />
            {hayImagenValida && (
              <button className="btn-ver-imagen" onClick={() => setMostrarImagen(true)}>📷 Ver imagen</button>
            )}
            <button
              className="btn-ok-continuar"
              onClick={() => {
                const next = (window)._nextRepaso || '';
                if (next && norm(next) === 'fin') {
                  (window)._nextRepaso = '';
                  avanzar(next);
                  return;
                }
                cerrarEfecto();
                if (next) {
                  (window)._nextRepaso = '';
                  avanzar(next);
                }
              }}
            >
              ✅ Ok
            </button>
          </div>
        ) : (
          <div className="carta-deslizable">
            <div className="imagen-y-boton" style={{ position: 'relative' }}>
              {resolveRol(preguntaActual?.Rol) && (
                <img
                  draggable="false"
                  src={resolveRol(preguntaActual?.Rol)}
                  alt={preguntaActual?.Rol || 'rol'}
                  className="img-enfermera"
                  style={{ transform: `translateX(${posicionX}px) rotate(${posicionX / 30}deg)`, transition: 'transform 0.25s ease' }}
                />
              )}
              {(preguntaActual.Imagen || preguntaActual.ImagenGral) &&
               resolveGeneral(preguntaActual.Imagen || preguntaActual.ImagenGral) && (
                <button
                  className="btn-ver-imagen"
                  style={{ position: 'absolute', top: '1px', left: '50%', transform: 'translateX(-50%)', zIndex: 2 }}
                  onClick={(e) => { e.stopPropagation(); setMostrarImagen(true); }}
                >
                  📷 Ver imagen
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  if (cargando || !preguntaActual) {
    return (
      <div className="cargando" style={{ backgroundImage: `url(${fondo})` }}>
        <div className="cuadro-carga">
          {cargando ? '⏳ Cargando Módulo de Repaso...' : '❌ No se pudo cargar la pregunta.'}
        </div>
      </div>
    );
  }

  return (
    <div className="nivel-basico-container" style={{ backgroundImage: `url(${fondo})` }}>
      <div className="estructura">
        <div className="barra-superior">
          <span className="usuario">👤 {usuario.toUpperCase()}</span>
          <div className="vidas-barra" />
          <span className="barra-tiempo">⏱ {Math.floor(tiempo / 60)}:{('0' + (tiempo % 60)).slice(-2)}</span>
        </div>

        <div className="bloque-central">
          <div className="titulo-y-pregunta">
            {preguntaActual.TituloHTML ? (
              <div
                className="titulo-carta"
                dangerouslySetInnerHTML={{ __html: reemplazarNombre(preguntaActual.TituloHTML) }}
              />
            ) : (
              preguntaActual.Titulo && <div className="titulo-carta">{preguntaActual.Titulo}</div>
            )}

            <p
              className="texto-pregunta"
              dangerouslySetInnerHTML={{
                __html: reemplazarNombre(preguntaActual.FraseHTML || preguntaActual.Frase || '')
              }}
            />
          </div>

          {renderPregunta()}
        </div>
      </div>

      {/* Barra inferior: logo IZQ + SOLO Volver */}
      <div className="barra-inferior">
        <div className="barra-izq">
          {imgGenerales['escudo_udec'] && (<img src={imgGenerales['escudo_udec']} alt="Escudo UdeC" />)}
        </div>

        <div className="nav-botones">
          <button className="btn-nav redondo" aria-label="Anterior" onClick={irAnteriorPorBoton} title="Volver">
            ⬅️
          </button>
        </div>

        <div className="barra-der" />
      </div>

      {mostrarImagen &&
      (preguntaActual?.Imagen || preguntaActual?.ImagenGral) &&
      resolveGeneral(preguntaActual.Imagen || preguntaActual.ImagenGral) && (
        <div className="modal-imagen" onClick={() => setMostrarImagen(false)}>
          <img
            src={resolveGeneral(preguntaActual.Imagen || preguntaActual.ImagenGral)}
            alt="Imagen asociada"
            className="imagen-expandida"
          />
          <button className="btn-cerrar-modal">✖️ Cerrar</button>
        </div>
      )}

      <ChatWidget />
    </div>
  );
};

export default NivelRepaso;
